<template>
   <div>
      <cust-editor-menu 
         class="editor-menu-window" 
         :editor="editor" 
         :fields="fields" 
         :images="images"
         :templateId="templateId" 
         @image-uploaded="imgUploaded"/>
      <div class="editor-window">
         <editor-content :editor="editor" />
      </div>
   </div>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-2'
import StarterKit from '@tiptap/starter-kit'
import HardBreak from '@tiptap/extension-hard-break'
import Code from '@tiptap/extension-code'
import CustEditorMenu from "@/components/CustEditorMenu"
import CustomImage from '../assets/js/custom-image'

export default {
   components: {
      EditorContent,
      'cust-editor-menu': CustEditorMenu
   },
   props: {
      value: {
         type: String,
         default: '',
      },
      fields: Array,
      images: Array,
      templateId: Number
   },
   data() {
      return {
         editor: null,
      }
   },

   watch: {
      value(value) {
         const isSame = this.editor.getHTML() === value
         if (isSame) {
            return
         }
         this.editor.commands.setContent(value, false)
      },
   },

   created() {
      this.editor = new Editor({
         content: this.value,
         extensions: [
            StarterKit.configure({
               hardBreak: false,
               code: false,
            }),
            HardBreak.extend({
               addKeyboardShortcuts() {
                  return {
                        Enter: () => {
                           if (this.editor.isActive('orderedList') || this.editor.isActive('bulletList')) {
                              return this.editor.chain().createParagraphNear().run();
                           }
                           return this.editor.commands.setHardBreak();
                        },
                  };
               },
            }),
            Code.configure({
               HTMLAttributes: {
                  class: 'code-field',
               },
            }),
            CustomImage.configure({
               HTMLAttributes: {
                  class: 'custom-image'
               }
            }),
         ],
         onUpdate: () => {
            this.$emit('input', this.editor.getHTML())
         },
      })
   },

   beforeDestroy() {
      this.editor.destroy()
   },

   methods: {
      getEditor() {
         return this.editor
      },
      imgUploaded() {
         this.$emit('img-uploaded', true)
      }
   }
}
</script>

<style lang="scss" scoped>
@import '../assets/css/colors.scss';
// Editor styles are in site.scss
</style>